import { render, staticRenderFns } from "./rolesWithUsers.vue?vue&type=template&id=18f4b083"
import script from "./rolesWithUsers.vue?vue&type=script&lang=js"
export * from "./rolesWithUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports